import { render, staticRenderFns } from "./RmrActionButton.vue?vue&type=template&id=34c5157c&scoped=true&"
import script from "./RmrActionButton.vue?vue&type=script&lang=js&"
export * from "./RmrActionButton.vue?vue&type=script&lang=js&"
import style0 from "./RmrActionButton.vue?vue&type=style&index=0&id=34c5157c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c5157c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
